export { default as CoreScrollTable } from './ScrollTable';